export const buildPlatformsRequestBody = (platforms = {}) =>
  Object.entries(platforms)
    .filter(([, value]) => Array.isArray(value))
    .map(([platform, value]) => ({
      platform,
      names: value.map((item) => item.value),
    }))
    .filter(({ names }) => names.length > 0);
